// extracted by mini-css-extract-plugin
module.exports = {"container":"OfferItem_container__3FqIL","article":"OfferItem_article__2RQ4g","sidebar":"OfferItem_sidebar__3YdLR"};